import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SlotType } from "../../../../enums/slot-type";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TddOptionComponent } from './tdd-option/tdd-option.component';

@Component({
    selector: 'oaibox-tdd-create-configuration',
    templateUrl: './tdd-create-configuration.component.html',
    styleUrls: ['./tdd-create-configuration.component.css'],
    imports: [ReactiveFormsModule, FormsModule, TddOptionComponent]
})
export class TddCreateConfigurationComponent {

  @Input() public defaultTddOptions?: string[];
  @Input() public editableTddOptions?: string[];
  @Output() public optionsChange: EventEmitter<string[]> = new EventEmitter();

  public tddSlots: SlotType[] = [SlotType.DOWNLINK, SlotType.DOWNLINK, SlotType.FLEXIBLE, SlotType.UPLINK, SlotType.UPLINK];

  constructor() {
  }

  public addTddOption(): void {
    let tddOption: string = this.tddSlots.map(slot => slot[0]).join('');
    if (!this.editableTddOptions) this.editableTddOptions = [];
    this.editableTddOptions.push(tddOption);
    this.optionsChange.emit(this.editableTddOptions);
  }

  public removeTddOption(index: number): void {
    this.editableTddOptions?.splice(index, 1);
    this.optionsChange.emit(this.editableTddOptions);
  }

  public switchTddType(): void {
    if (this.tddSlots.length === 5) {
      this.tddSlots = [SlotType.DOWNLINK, SlotType.DOWNLINK, SlotType.DOWNLINK, SlotType.DOWNLINK, SlotType.FLEXIBLE, SlotType.FLEXIBLE, SlotType.UPLINK, SlotType.UPLINK, SlotType.UPLINK, SlotType.UPLINK];
    } else {
      this.tddSlots = [SlotType.DOWNLINK, SlotType.DOWNLINK, SlotType.FLEXIBLE, SlotType.UPLINK, SlotType.UPLINK];
    }
  }

  public loopSlot(slotIndex: number): void {
    const slotTypes = Object.values(SlotType);
    this.tddSlots[slotIndex] = slotTypes[(slotTypes.indexOf(this.tddSlots[slotIndex]) + 1) % slotTypes.length];
  }
}
